import { CWTSchemaPropertySummary } from '../../../../../types/custom-worksheet-v2';
import { ReactComponent as TackIcon } from '../../../../../assets/tack.svg';
import CWReadField from '../field/CWReadField';
import FlashBackground from '../FlashBackground';
import QuickActions from '../field/QuickActions';

type SummaryFieldProps = {
    showLabel?: boolean;
    summary: CWTSchemaPropertySummary;
};

function SummaryField({ showLabel = true, summary }: SummaryFieldProps): JSX.Element {
    if (summary?.calculation.return.params.length === 0) {
        return <></>;
    }

    return (
        <div id={summary.id} className="scroll-mt-8 flex justify-between items-center relative">
            <FlashBackground id={summary.id} />
            {showLabel && (
                <>
                    <div className="absolute -left-5 top-3">
                        <TackIcon style={{ fill: '#16A249' }} />
                    </div>
                    <p className="text-gray-600 text-sm">Total</p>
                </>
            )}
            <div className="w-[300px] flex gap-1 items-center mr-0.5">
                <QuickActions field={summary} actions={summary.quickActions} />
                {!showLabel && <TackIcon style={{ fill: '#16A249' }} className="shrink-0" />}
                <CWReadField mode="keyValue" alignment="right" showIcon field={summary} />
            </div>
        </div>
    );
}

export default SummaryField;
